// Mirrors the backend uploader: the server rejects anything else anyway.
export const ACCEPTED_EXTENSIONS = ['.pdf', '.doc', '.docx', '.xls', '.xlsx'];
export const MAX_FILE_BYTES = 50 * 1024 * 1024;

/** Why this file can't be uploaded, or null if it's fine. */
export const checkContractFile = (file: File): string | null => {
  const ext = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
  if (!ACCEPTED_EXTENSIONS.includes(ext)) return 'Use a PDF, Word or Excel file.';
  if (file.size > MAX_FILE_BYTES) return 'The file is larger than 50 MB.';
  return null;
};
